import React, { useRef, FC, useMemo, useState } from "react";

import DataGrid, {
  Column,
  ColumnChooser,
  Export,
  FilterPanel,
  FilterRow,
  GroupPanel,
  HeaderFilter,
  Pager,
  Paging,
  StateStoring,
} from "devextreme-react/data-grid";
import { Button } from "devextreme-react/button";

import { AppLayoutTop, AppCard } from "components/appComponents";
import $createStore from "utils/create-store-instance";
import { CashItemDeleteModal } from "../../../CashFlow/components";
import { useHistory, useParams } from "react-router";
import { onExporting } from "utils/exportingExcel";
import { MONEY_FORMAT } from "constants/formats";
import ClaimsProvider from "components/claimsBlock";
import { useAuth } from "context/auth";
import { CashTotals } from "pages/Cash/components";
import { useGetCashFlowTotalQuery } from "bus/cash";

const CashFlow: FC = () => {
  const history = useHistory();
  const { getClaims }:any = useAuth();
  const { id } = useParams<{ id: string }>();

  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [cashFlowId, setCashFlowId] = useState<number | null>(null);

  const { refetch } = useGetCashFlowTotalQuery(undefined, { refetchOnMountOrArgChange: true });

  const requestDateSource = useMemo(() => {
    return $createStore(`/v1/CashFlowIncomeOwner`, "cashFlowId");
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => {
    refGrid.current?.instance.refresh();
    refetch();
  }

  const goToDetailHandler = ({ data }: any) => {
    if(getClaims(['CanEditIncomeOwner'])) {
      history.push(`/cash-flow/${data.cashFlowId}`);
    }
  }

  return (
    <div className="container-dev">
      {modalIsVisibleDelete && (
        <CashItemDeleteModal
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          id={cashFlowId}
        />
      )}

      <AppLayoutTop title="Поступление от владельца">
        <ClaimsProvider claimsBlock={['CanCreateIncomeOwner']}>
          <Button
            width={120}
            text="Создать"
            type="default"
            onClick={() => history.push(`/cash-flow-add/${id}`)}
          />
        </ClaimsProvider>
      </AppLayoutTop>

      <CashTotals />

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: "Загрузка",
          }}
          ref={refGrid}
          remoteOperations={true}
          allowColumnResizing
          columnResizingMode="nextColumn"
          columnMinWidth={50}
          allowColumnReordering
          onRowDblClick={goToDetailHandler}
          onExporting={onExporting}
        >
          <Export enabled={true} />
          <StateStoring
            enabled={true}
            type="localStorage"
            storageKey="CashFlowIncomeOwner"
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <HeaderFilter visible />
          <GroupPanel visible={true} />
          <ColumnChooser enabled={true} />
          <Column dataField="date" caption="Дата" dataType="date" width={150} />
          <Column dataField="cashFlowItemName" caption="Статья движения ДС" /> 
          <Column dataField="sum" caption="Сумма" format={MONEY_FORMAT}  />
          <Column dataField="comment" caption="Комментарий" />
          <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditIncomeOwner']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => goToDetailHandler(data)}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteIncomeOwner']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setCashFlowId(data.data.cashFlowId);
                      setModalIsVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />
          <Paging defaultPageSize={15} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={[15, 30, 50, 100]}
          />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default CashFlow;
